/*!
 * KoliBri - The accessible HTML-Standard
 */
import { c as createPropDefinition, n as normalizeString } from './normalizers-BNeak4hj.js';

const srcProp = createPropDefinition('src', '', normalizeString);

export { srcProp as s };
//# sourceMappingURL=src-BnjoA2Q6.js.map

//# sourceMappingURL=src-BnjoA2Q6.js.map